import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension'; // eslint-disable-line import/no-extraneous-dependencies
import logger from 'redux-logger';

import createRootReducer from './reducers';
import rootSaga from './sagas';
import { isProduction } from '../lib/utils';

export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

let middleware = applyMiddleware(sagaMiddleware);

if (!isProduction()) {
  middleware = composeWithDevTools(
    applyMiddleware(
      routerMiddleware(history), // for dispatching history actions
      sagaMiddleware,
      logger,
    ),
  );
} else {
  middleware = applyMiddleware(
    routerMiddleware(history), // for dispatching history actions
    sagaMiddleware,
  );
}

export default function configureStore(preloadedState) {
  const store = createStore(
    createRootReducer(history), // root reducer with router state
    preloadedState,
    middleware,
  );

  sagaMiddleware.run(rootSaga);

  return store;
}
